import { Input } from 'components/ui/input';
import { Control, Controller, FieldValues, Path } from 'react-hook-form';
import { t } from 'utils/getTranslations';
import InputWrapper from './InputWrapper';
import { useMemoizedRules } from './useMemoizedRules';

type ChangeReasonInputProps<T extends FieldValues> = {
    control: Control<T>;
    name: Path<T>;
    required: boolean;
};

const ChangeReasonInput = <T extends FieldValues>({ control, name, required }: ChangeReasonInputProps<T>) => {
    const rules = useMemoizedRules({ required });

    return (
        <div className="mt-2">
            <Controller
                control={control}
                name={name}
                rules={rules}
                render={({ field: { ref, value, onChange, onBlur }, fieldState: { error } }) => (
                    <InputWrapper
                        name={name}
                        label="change-reason.label"
                        required={required}
                        hasErrors={!!error}
                        error={error}
                    >
                        <Input
                            id={name}
                            ref={ref}
                            className="bg-paper"
                            value={value ?? ''}
                            onChange={onChange}
                            onBlur={onBlur}
                            aria-invalid={!!error}
                            placeholder={t('change-reason.placeholder')}
                            data-form-type="other"
                            data-lpignore="true"
                        />
                    </InputWrapper>
                )}
            />
        </div>
    );
};

export default ChangeReasonInput;
